import Image from 'next/image';
import { useTranslation } from 'react-i18next';

import TPLink from '@/components/TPLink';

import useTrustpilotScore from './useTrustpilotScore';

const sizeConfig = {
  sm: {
    text: 'text-[14px]',
    image: 'h-[14px] w-[81px] lg:h-4 lg:w-[92px] xl:h-[20px] xl:w-[115px]',
  },
  md: {
    text: 'text-[14px] lg:text-[16px]',
    image: 'h-5 w-[116px] lg:h-4 lg:w-[92px] xl:h-5 xl:w-[115px]',
  },
};

const TrustpilotBar: React.FC<{
  size?: 'sm' | 'md';
  className?: string;
}> = ({ size = 'sm', className }) => {
  const { i18n } = useTranslation();
  const tpScore = useTrustpilotScore();
  const scoreText = i18n.language === 'zh' ? `${tpScore} 分` : tpScore;
  const config = sizeConfig[size];

  return (
    <TPLink
      className={`flex items-center justify-center space-x-2 ${className ?? ''}`}>
      <span className={`font-medium text-text-primary ${config.text}`}>
        Trustpilot
      </span>
      <span className={config.image}>
        <Image
          alt="Trustpilot rating"
          width={115}
          height={20}
          src="/images/home/userReviews-tp2.png"
          quality={100}
          className="w-full"
        />
      </span>
      <span className={`font-medium text-text-primary ${config.text}`}>
        {scoreText}
      </span>
    </TPLink>
  );
};

export default TrustpilotBar;
